import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import HeroRecruitment from './HeroRecruitment';
import RecruitmentInfo from './RecruitmentInfo';
import RecruitmentDetail from './RecruitmentDetail';

const Recruitment = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <HeroRecruitment />
            <RecruitmentInfo />
            <RecruitmentDetail />
            <Footer hclass={'footer-section section-padding'} />
            <Scrollbar />
        </Fragment>
    );
};

export default Recruitment;
